var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"banner"}},[_c('div',{staticClass:"swiper-container swiper-container2"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.bannerList),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c('img',{attrs:{"src":item.coverImgUrl,"alt":""}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }